import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes,RouterModule } from '@angular/router';

import { AdminComponent } from "./admin/admin.component";
import { ClientListComponent } from './client-list/client-list.component';
import { ClientNewComponent } from './client-new/client-new.component';
import { ClientEditComponent } from './client-edit/client-edit.component';

import { AssessmentAdminComponent } from "./assessment-admin/assessment-admin.component";
import { AssessmentListComponent } from "./assessment-list/assessment-list.component";
import { AssessmentNewComponent } from "./assessment-new/assessment-new.component";
import { AssessmentEditComponent } from "./assessment-edit/assessment-edit.component";
import { AssessmentResultViewComponent } from "app/reports/assessment-result-view/assessment-result-view.component";

import { QuestionSetEditComponent } from "./question-set-edit/question-set-edit.component";
import { QuestionSetNewComponent } from "./question-set-new/question-set-new.component";

import { ScaleNewComponent } from "./scale-new/scale-new.component";
import { ScaleEditComponent } from "./scale-edit/scale-edit.component";

import { QuestionNewComponent } from './question-new/question-new.component';
import { QuestionEditComponent } from './question-edit/question-edit.component';

import { LabelNewComponent } from './label-new/label-new.component';
import { LabelEditComponent } from './label-edit/label-edit.component';

import { ScaleRangeNewComponent } from './scale-range-new/scale-range-new.component';
import { ScaleRangeEditComponent } from './scale-range-edit/scale-range-edit.component';

import {AdminGuard } from "../login/services/admin-guard.service"

import { AdminShopComponent } from './admin-shop/admin-shop.component';
import { ShopItemsComponent } from './shop-items/shop-items.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { CheckoutThankyouComponent } from './checkout-thankyou/checkout-thankyou.component';

import { MyAccountComponent } from "./my-account/my-account.component";
import { ViewOrderPageComponent } from "./view-order-page/view-order-page.component";

import {ReportViewerComponent} from "../reports/report-viewer/report-viewer.component";

import {AssessmentGroupEditComponent} from "./assessment-group-edit/assessment-group-edit.component";
import { UsersModule} from "../users/users.module";
import { CompaniesAdminModule } from 'app/companies-admin/companies-admin.module';
import { AssessmentViewComponent } from 'app/admin/assessment-view/assessment-view.component';
import { ScalesListViewComponent } from "./scales-list-view/scales-list-view.component";
import { QuestionSetListViewComponent } from "./question-set-list-view/question-set-list-view.component";
import { AssessmentDetailsViewComponent } from 'app/admin/assessment-details-view/assessment-details-view.component';
import { OrderHistoryComponent } from './order-history/order-history.component';
import { AccountOwnerSettingsComponent } from 'app/account-owner-settings/account-owner-settings.component';
import { BillingDetailsComponent } from 'app/shared/billing-details/billing-details.component';
import { BillingPlansComponent } from './billing-plans/billing-plans.component';
import { AssetResultViewComponent } from 'app/reports/asset-result-view/asset-result-view.component';
import { ExerciseListComponent } from 'app/library-assets/exercise-list/exercise-list.component';
import { AdminViewAssetComponent } from 'app/library-assets/admin-view-asset/admin-view-asset.component';

// TODO: stephen not sure why I need this function instead of a lambda
export function ReturnUsersModules() {
  return UsersModule;
}

export function ReturnCompaniesAdminModules() {
  return CompaniesAdminModule;
}

export const adminRoutes: Routes = [{
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: '',
        children: [
          { path: 'client', children: [
            { path: 'new',  component: ClientNewComponent }
            ,{ path: ':id',  children: [
                {path: '', component: ClientEditComponent }
                ,{path: 'result/:resultId', component: AssessmentResultViewComponent }
                ,{path: 'asset-result/:resultId', component: AssetResultViewComponent }
                ,{path: 'report/:reportId/:assignmentId', component: ReportViewerComponent }
            ]}
            ,{ path: '', component: ClientListComponent}
          ]}
          ,{path: 'users', 'loadChildren': '../users/users.module#UsersModule'}
          ,{path: 'companies', loadChildren: '../companies-admin/companies-admin.module#CompaniesAdminModule' }
          ,{path: 'system', loadChildren: './system-overview/system-overview.module#SystemOverviewModule'}
          
          // TODO: stephen would this be better as a child component of client?

          // ,{ path: 'shop', component: AdminShopComponent }
          ,{ path: 'shop', children: [
            { path: '', component: ShopItemsComponent }
            ,{ path: 'checkout/thankyou', component: CheckoutThankyouComponent }
            ,{ path: 'checkout', component: CheckoutComponent }
          ]}
          
          
          ,{ path: 'assessment', component: AssessmentAdminComponent,
            children: [
              {path: 'batteries', component: AssessmentGroupEditComponent}
              ,{path: 'custom-reports', loadChildren: '../manage-reports/manage-reports.module#ManageReportsModule' }
              ,{path: 'manage', children: [
                { path: '',component: AssessmentListComponent}
                ,{ path: 'new', component: AssessmentNewComponent }
                ,{ path: ':uid/view', component: AssessmentViewComponent, children: [
                  { path: '', redirectTo: 'details', pathMatch: 'prefix' }
                  ,{ path: 'details', component: AssessmentDetailsViewComponent }
                  ,{ path: 'scales', component: ScalesListViewComponent }
                  ,{ path: 'sets', component: QuestionSetListViewComponent }
                ] }
                ,{ path: ':uid/edit', component: AssessmentEditComponent, children: [] }
                ,{ path: ':uid/edit/question-set', children: [
                  { path: ':setId/edit', component: QuestionSetEditComponent }
                  ,{ path: 'new', component: QuestionSetNewComponent }
                ] }
                // even though it seems question is a sub of question-set we have no router outlet
                // for it... we want it to replace the entire screen... so... we do this.
                ,{ path: ':uid/edit/question-set/:setId/edit/question', children: [
                    {path: 'new', component: QuestionNewComponent}
                    ,{path: ':questionId/edit', component: QuestionEditComponent}
                  ] }
                ,{ path: ':uid/edit/question-set/:setId/edit/label', children: [
                    {path: 'new', component: LabelNewComponent}
                    ,{path: ':labelId/edit', component: LabelEditComponent}
                  ] }
                ,{ path: ':uid/edit/scale', children: [
                  { path: ':scaleId/edit', component: ScaleEditComponent }
                  ,{ path: 'new', component: ScaleNewComponent }
                ] }
                ,{ path: ':uid/edit/scale/:scaleId/edit/scale-range', children: [
                    {path: 'new', component: ScaleRangeNewComponent}
                    ,{path: ':rangeId/edit', component: ScaleRangeEditComponent}
                  ] }
              ]}
            ]
          }

          // library assets
          , { path: 'library/:type', component: ExerciseListComponent, children: [] }
          , { path: 'library/:type/:assetId', component: AdminViewAssetComponent, children: [] }

          ,{ path: 'my-account', component: MyAccountComponent, children: [
            { path: 'order', component: OrderHistoryComponent }
            , { path: 'order/:id', component: ViewOrderPageComponent}
            ,{ path: 'billing', component: BillingDetailsComponent }
            ,{ path: 'plans', component: BillingPlansComponent }
            ,{ path: 'company', component: AccountOwnerSettingsComponent }
            , { path: '', pathMatch: 'full', redirectTo: '/admin/my-account/order' }
          ]}
          ,{ path: '**', redirectTo: '/admin/client', pathMatch: 'full'}

 // 
  
  // { path: 'assessments/:uid/edit/scale/new', component: AssessmentScaleNewComponent },
  // { path: 'assessments/:uid/edit/scale/:scaleId/edit', component: AssessmentScaleEditComponent },

  // { path: 'assessments/:uid/edit/scale/:scaleId/edit/scale-range/new', component: AssessmentScaleRangeNewComponent },
  // { path: 'assessments/:uid/edit/scale/:scaleId/edit/scale-range/:rangeId/edit', component: AssessmentScaleRangeEditComponent },
  
  // { path: 'assessments/:uid/edit/questionSet/new', component: QuestionSetNewComponent },
  // { path: 'assessments/:uid/edit/questionSet/:setId/edit', component: QuestionSetEditComponent },

  // { path: 'assessments/:uid/edit/questionSet/:setId/edit/question/new', QuestionNewComponent  },
  // { path: 'assessments/:uid/edit/questionSet/:setId/edit/question/:questionId', QuestionEditComponent  },

  // { path: 'assessments/:uid/edit/questionSet/:setId/edit/label/new', QuestionSetLabelNewComponent  },
  // { path: 'assessments/:uid/edit/questionSet/:setId/edit/label/:labelId', QuestionSetLabelEditComponent  },

        ]
    }
  ]
}];
@NgModule({
  imports: [
    RouterModule.forChild(adminRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class AdminRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/admin/admin-routing.module.ts